import { useSoundEnabled } from './sound-preference';
import styles from './SoundToggle.module.css';

/** Liga e desliga o som de mensagem nova (a preferência fica neste navegador). */
export function SoundToggle() {
  const [enabled, setEnabled] = useSoundEnabled();
  return (
    <button
      type="button"
      className={styles.toggle}
      aria-pressed={enabled}
      onClick={() => setEnabled(!enabled)}
    >
      Som de mensagem nova: {enabled ? 'ligado' : 'desligado'}
    </button>
  );
}
